
// Form Validator Module
const FormValidator = (function() {
  var currentYear = new Date().getFullYear();
  var MIN_YEAR = 1800;
  var MAX_YEAR = currentYear;

  function getYearFromValue(value) {
    if (!value || !value.trim()) return null;
    var str = value.trim();
    if (str.length >= 4) {
      var y = parseInt(str.substring(0, 4), 10);
      return isNaN(y) ? null : y;
    }
    var num = parseInt(str, 10);
    return isNaN(num) ? null : num;
  }

  function isValidYear(value) {
    var year = getYearFromValue(value);
    return year !== null && year >= MIN_YEAR && year <= MAX_YEAR;
  }

  function validateField(field) {
    var value = field.value.trim();
    var isYearField = field.id === 'year-established';
    var isValid;

    if (isYearField) {
      isValid = value !== '' && isValidYear(value);
    } else {
      isValid = value !== '';
    }

    if (!isValid) {
      field.classList.add('field-error');
    } else {
      field.classList.remove('field-error');
    }
    return isValid;
  }

  function setupInputValidation(form) {
    var inputs = form.querySelectorAll('input, select, textarea');
    inputs.forEach(function(input) {
      input.addEventListener('input', function() {
        this.classList.remove('field-error');
      });
    });
  }

  return {
    init: function(form) {
      setupInputValidation(form);
    },
    validateForm: function(form) {
      var requiredFields = form.querySelectorAll('[required]');
      var isValid = true;

      requiredFields.forEach(function(field) {
        if (!validateField(field)) {
          isValid = false;
        }
      });

      if (!isValid) {
        UIFeedback.showError('Please fill in all required fields with valid values. Year Established must be between 1800 and ' + currentYear + '.');
      }

      return isValid;
    },
    isValidYear: isValidYear,
    yearRange: { min: MIN_YEAR, max: MAX_YEAR }
  };
})();

// File Handler Module
const FileHandler = (function() {
  const UPLOAD_ENDPOINT = gadgetAppUrl + '/azureUpload';

  async function uploadFile(file) {
    if (!file) return null;

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(UPLOAD_ENDPOINT, {
        method: 'POST',
        body: formData
      });
      if (!response.ok) {
        throw new Error(`File upload failed: ${response.status}`);
      }
      const uploadData = await response.json();
      return uploadData.fileName || uploadData.filename || uploadData.name;
    } catch (error) {
      console.error('File upload error:', error);
      throw new Error('There was an error uploading the file. Please try again.');
    }
  }

  return {
    uploadFile,
    updateFileInfo: function(fileInput, fileInfo) {
      if (fileInput.files.length > 0) {
        fileInfo.textContent = fileInput.files[0].name;
      } else {
        fileInfo.textContent = 'No file chosen';
      }
    }
  };
})();

// Form Submission Module
const FormSubmission = (function() {
  const SUBMIT_ENDPOINT = gadgetAppUrl + '/distributorSubmit';

  function collectFormData(form) {
    var yearEstablishedInput = form.querySelector('#year-established').value;
    var yearlyRevenueInput = form.querySelector('#yearly-revenue').value;
    // Year established: up to 4 digits (validated on submit). Yearly revenue: round to nearest whole number.
    var yearEstablished = '';
    if (yearEstablishedInput) {
      var yearPart = yearEstablishedInput.trim().substring(0, 4);
      yearEstablished = yearPart.length === 4 ? yearPart : '';
    }
    var yearlyRevenue = yearlyRevenueInput !== '' ? String(Math.round(parseFloat(yearlyRevenueInput) || 0)) : '';

    return {
      firstName: form.querySelector('#first-name').value,
      lastName: form.querySelector('#last-name').value,
      phone: form.querySelector('#phone').value,
      email: form.querySelector('#email').value,
      companyName: form.querySelector('#company-name').value,
      countryRegion: form.querySelector('#country-region').value,
      typeOfBusiness: form.querySelector('#type-of-business').value,
      yearEstablished: yearEstablished,
      salesType: form.querySelector('#sales-type').value,
      yearlyRevenue: yearlyRevenue,
      currency: form.querySelector('#currency').value,
      message: form.querySelector('#message').value,
      privacyPolicy: form.querySelector('#privacy-policy').checked
    };
  }

  async function submitForm(formData, fileName = null) {
    if (fileName) {
      formData.fileName = fileName;
    }

    try {
      const response = await fetch(SUBMIT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          formData: JSON.stringify(formData)
        })
      });

      if (!response.ok) {
        throw new Error(`Form submission failed: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Form submission error:', error);
      throw new Error('There was an error submitting the form. Please try again.');
    }
  }

  return {
      collectFormData,
      submitForm
  };
})();

// UI Feedback Module
const UIFeedback = (function() {
  function showSuccessBanner(title = 'Application Submitted Successfully!', message = 'Thank you for your distributor application. We will review your submission and get back to you soon.') {
    const banner = document.createElement('div');
    banner.className = 'success-banner';
    banner.innerHTML = `
      <div class="success-content">
        <div class="success-icon">✓</div>
        <h3>${title}</h3>
        <p>${message}</p>
        <button onclick="this.parentElement.parentElement.remove()" class="close-btn">×</button>
      </div>
    `;
    document.body.appendChild(banner);
    setTimeout(() => {
      if (banner.parentElement) {
        banner.remove();
      }
    }, 10000);
  }

  return {
    showSuccessBanner,
    showError: function(message) {
      alert(message);
    },
    updateButtonState: function(button, isLoading, originalText) {
      if (isLoading) {
        button.textContent = 'Submitting...';
        button.disabled = true;
      } else {
        button.textContent = originalText;
        button.disabled = false;
      }
    }
  };
})();

// Main Form Handler
const DistributorForm = (function() {
  let form;
  let submitButton;
  let fileInput;
  let fileInfo;

  function init() {
    form = document.getElementById('distributor-form');
    if (!form) return;

    submitButton = form.querySelector('.btn-primary');
    fileInput = document.getElementById('resume-file');
    fileInfo = document.querySelector('.file-info');

    FormValidator.init(form);
    setupEventListeners();
  }

  function setupEventListeners() {
    form.addEventListener('submit', handleSubmit);

    var yearEstablishedInput = form.querySelector('#year-established');
    if (yearEstablishedInput) {
      yearEstablishedInput.addEventListener('input', function() {
        var digitsOnly = this.value.replace(/\D/g, '');
        if (digitsOnly.length > 4) {
          digitsOnly = digitsOnly.slice(0, 4);
        }
        if (digitsOnly !== this.value) {
          this.value = digitsOnly;
        }
        this.classList.remove('field-error');
      });
      yearEstablishedInput.addEventListener('blur', function() {
        var val = this.value.trim();
        if (val !== '' && !FormValidator.isValidYear(val)) {
          this.value = '';
          this.classList.add('field-error');
        }
      });
    }

    var yearlyRevenueInput = form.querySelector('#yearly-revenue');
    if (yearlyRevenueInput) {
      yearlyRevenueInput.addEventListener('blur', function() {
        var val = parseFloat(this.value);
        if (!isNaN(val)) {
          this.value = Math.round(val);
        }
      });
    }

    if (fileInput && fileInfo) {
      fileInput.addEventListener('change', () => {
        FileHandler.updateFileInfo(fileInput, fileInfo);
      });
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!FormValidator.validateForm(form)) {
      return;
    }

    const originalButtonText = submitButton.textContent;
    UIFeedback.updateButtonState(submitButton, true, originalButtonText);

    try {
      // Handle file upload if present
      let fileName = null;
      if (fileInput && fileInput.files.length > 0) {
        fileName = await FileHandler.uploadFile(fileInput.files[0]);
      }

      // Collect and submit form data
      const formData = FormSubmission.collectFormData(form);
      await FormSubmission.submitForm(formData, fileName);

      // Show success message and reset form
      UIFeedback.showSuccessBanner();
      form.reset();
      if (fileInfo) {
        fileInfo.textContent = 'No file chosen';
      }
    } catch (error) {
        UIFeedback.showError(error.message);
    } finally {
        UIFeedback.updateButtonState(submitButton, false, originalButtonText);
    }
  }

  return {
    init
  };
})();

// Initialize form when DOM is loaded
document.addEventListener('DOMContentLoaded', DistributorForm.init);